var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('v-alert',{staticClass:"mb-0",attrs:{"type":"error","tile":""}},[_vm._v("\n  "+_vm._s(_vm.error.response?.data?.message || _vm.error.message || _vm.error || 'Unknown error')+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }